import RailHoverBubble from '@/shared/components/RailHoverBubble/RailHoverBubble'
import useRailHoverLabel from '@/shared/components/RailHoverBubble/useRailHoverLabel'
import useRightPanelToggle from './useRightPanelToggle'
import { PanelToggleButton } from './styled-components'

const RightPanelToggle = () => {
  const { expanded, onToggle, Icon, iconColor, label } = useRightPanelToggle()
  const { anchorRef, geometry, show, hide } = useRailHoverLabel<HTMLButtonElement>()

  return (
    <>
      <PanelToggleButton
        ref={anchorRef}
        type='button'
        data-panel-toggle
        aria-expanded={expanded}
        aria-label={label}
        onClick={onToggle}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        <Icon size={20} color={iconColor} />
      </PanelToggleButton>
      <RailHoverBubble geometry={geometry} label={label} side='left' />
    </>
  )
}

export default RightPanelToggle
